import Driver from 'driver.js';
import {Panes} from "../controllers/panes";
import {GeoAppEvents} from "../controllers/events/geoapp_events";
import {FeaturesEvents} from "../services/events/FeaturesEvents";
import {SearchService} from "../services/search";
import * as SMapTourSteps from './steps';
import {
    simulateOpenLayersEvent,
    waitFor,
    togglePane,
    _workAroundMoveNext,
    TourStatus,
    resetMap,
    moveMap, startWhenReady, timeoutHandler, onActivate, onReset, delay
} from "./commands";
import {isPortrait} from "./util";
import {LTServices} from "../lt-ng/lt-services";
import IMapService = LTServices.IMapService;
import {reportsMenuMobile} from "./steps";
import {IFeatureState} from "../services/feature_state";


export function startTour(useDriver: Driver = null, startStepId: string = null, restarted: boolean = false): TourStatus {
    const driverOptions = {
        animate: true,
        stageBackground: "transparent",
        allowClose: false,
        onReset,
        onNext: () => {
            console.log('global onNext')
        }
    };

    onActivate();

    let driver = useDriver || new Driver(driverOptions);

    let steps: (restarted?:boolean) => any[];

    let appElement = document.querySelector('[ng-app=map]');
    let app = window['angular'].element(appElement);
    let appScope: ng.IScope = app.scope();

    let mapService: () => IMapService = () => app.injector().get('landcareMapService');
    let featureState: () => IFeatureState = () => app.injector().get('featureState');
    let searchService: SearchService;
    let coordAdjustment = () => app.injector().get('coordinateAdjustmentService');

    const workAroundMoveNext = (id) => _workAroundMoveNext(driver, steps(), id);

    const simpleNext = (aStep) => {
        driver.preventMove();
        setTimeout(() => workAroundMoveNext(aStep), 16);
    };

    const doLinzQuery = (nextStep: string) => {
        waitFor('[data-feature-action="predefinedAreaMobile"][data-layer="LINZ Parcels"]')
            .then(reportButton => reportButton.click())
            .then(() => waitFor('.active-mode-title.add-feature-action-label'))
            .then(() => {
                return mapService().getActiveClickInteraction()
            })
            .then((interaction) => {
                appScope.$apply(() => {
                    try {
                        simulateOpenLayersEvent(mapService().map, interaction, 'click', 0, 0);
                    } catch (e) {
                        console.warn(e);
                    }
                });
                return workAroundMoveNext(nextStep);
            }).catch(timeoutHandler(driver));
    };

    steps = (restartTour: boolean = false) => {
        const theSteps = [
            {
                _id: 'a',
                element: 'main',
                popover: {
                    ...SMapTourSteps.introMobile,
                    position: 'mid-center'
                },
                onNext: () => simpleNext('b')
            },
            {
                _id: 'b',
                element: ".tile-nav-xs",
                popover: {...SMapTourSteps.mainButtonsMobile()},
                onNext: () => simpleNext('c'),
                onPrevious: () => simpleNext('a')
            },
            {
                _id: 'c',
                element: ".tile-nav-xs li.search",
                popover: {
                    ...SMapTourSteps.search,
                    position: isPortrait() ? undefined : "right-center"/*,
                position: 'bottom-center'*/
                },
                onPrevious: () => simpleNext('b'),
                onNext: () => {
                    driver.preventMove();

                    appScope.$apply(() => {
                        (<HTMLElement>document.querySelector('[data-action="showModal:Search"]'))
                            .click();
                    });

                    waitFor('.modal.in:not(.ng-enter)')
                        .then(() => waitFor('.modal-dialog input[type=search]'))
                        .then((search: HTMLInputElement) => {
                            search.blur();
                            workAroundMoveNext('c2');
                        }).catch(timeoutHandler(driver));
                }
            },
            {
                _id: 'c2',
                element: isPortrait() ? '.modal-dialog' : '.modal-dialog input',
                popover: {
                    ...SMapTourSteps.search,
                    position: 'bottom-center'
                },
                onNext: () => {
                    driver.preventMove();

                    const searchInput = <HTMLInputElement> document.querySelector(".modal-content input");
                    const textToType = "Mount Maunganui".split('').reverse();

                    searchInput.click();
                    searchInput.focus();
                    let typedCoord = '';

                    searchService = searchService || app.injector().get('searchService');

                    const typing = setInterval(() => {
                        if (textToType.length) {
                            appScope.$apply(() => {
                                const key = textToType.pop();
                                typedCoord += key;
                                searchInput.value = typedCoord;
                                searchInput.dispatchEvent(new KeyboardEvent('keydown', { key, bubbles: true, cancelable: true }));
                                searchInput.dispatchEvent(new KeyboardEvent('keyup', { key, bubbles: true, cancelable: true }));
                            });
                        } else {
                            driver.reset(true);
                            onActivate();
                            clearInterval(typing);

                            const coordinate = coordAdjustment().adjustCentreForScreenSpace([1879921.6885150375, 5830466.109067537], window['map'], 9);
                            searchService.animateZoomTo(coordinate, 15);
                            searchService.highlightLocation(coordinate, 4000);

                            setTimeout(() => {
                                searchInput.value = '';
                                (<HTMLElement> document.querySelector('[data-dismiss="modal"]'))
                                    .click();

                                setTimeout(() => {
                                    workAroundMoveNext('d');
                                }, 500)

                            }, 1500);

                        }
                    }, 20);
                },
                onPrevious: () => {
                    driver.preventMove();
                    const dismissModal = document.querySelector('[data-dismiss="modal"]');

                    if (dismissModal instanceof HTMLElement) {
                        dismissModal.click();
                    }

                    workAroundMoveNext('c')
                }
            },
            {
                _id: 'd',
                element: ".ol-zoom.ol-control",
                popover: {
                    ...SMapTourSteps.mapNavTouch,
                    position: isPortrait() ? "right-center" : "bottom-left"
                },
                onNext: () => simpleNext('e'),
                onPrevious: () => {
                    resetMap(appScope, coordAdjustment());
                    simpleNext('c')
                }
            },
            {
                _id: 'e',
                element: ".tile-nav-xs li.layers",
                popover: {
                    ...SMapTourSteps.changingLayersTouch,
                    position: isPortrait() ? "bottom-right" : "right-bottom",
                    className: 'driver-popover-layers'
                },
                onNext: () => {
                    driver.preventMove();
                    togglePane(appScope, Panes.Ids.LAYERS, true)
                        .then(() => Promise.all(<any> [
                            waitFor('.pane-container:not(.pane-collapse-xs)'),
                            waitFor(".inset-pane-xs #PaneLayers .pane-content")
                        ]))
                        .then(() => workAroundMoveNext('e2'))
                        .catch(timeoutHandler(driver));
                },
                onPrevious: () => simpleNext('d')
            },
            {
                _id: 'e2',
                element: ".pane-container:not(.pane-collapse-xs) .inset-pane-xs",
                popover: {
                    ...SMapTourSteps.changingLayersTouch,
                    position: isPortrait() ? "top-center" : 'left-center'
                },
                onNext: () => {
                    driver.preventMove();
                    togglePane(appScope, Panes.Ids.LAYERS, false);
                    // showPane(Panes.Ids.FEATURES);
                    setTimeout(() => workAroundMoveNext('f0'), 50);
                },
                onPrevious: () => {
                    driver.preventMove();
                    togglePane(appScope, Panes.Ids.LAYERS, false)
                        .then(() => waitFor('.pane-container.pane-collapse-xs'))
                        .then(() => workAroundMoveNext('e'))
                        .catch(timeoutHandler(driver));
                }
            },
            {
                _id: 'f0',
                element: "main",
                popover: {
                    ...SMapTourSteps.reportingMobile,
                    position: 'mid-center',
                },
                onNext() {
                    moveMap(mapService().map, coordAdjustment(), [1879921.6885150375, 5830466.109067537], 9);
                    driver.preventMove();

                    const coord = coordAdjustment().adjustCentreForScreenSpace([1879921.6885150375, 5830466.109067537], window['map'], 9);

                    appScope.$apply(() => {
                        appScope.$broadcast(GeoAppEvents.queryPoint, coord);
                        waitFor('.inset-pane-xs point-report-list')
                            .then((list) => {
                                list.scrollIntoView();
                                workAroundMoveNext('i')
                            });
                    });
                },
                onPrevious() {
                    driver.preventMove();
                    togglePane(appScope, Panes.Ids.LAYERS, true)
                        .catch(() => {})
                        .then(() => waitFor(".inset-pane-xs #PaneLayers .pane-content")
                        .then(() => workAroundMoveNext('e2'))
                        .catch(timeoutHandler(driver)));
                    // simpleNext('e2');
                }
            },
/*            {
                _id: 'h',
                element: 'main',
                popover: {
                    ...SMapTourSteps.soilSummaryPt2Touch,
                    position: 'mid-center'
                },
                onNext: () => {
                    driver.preventMove();

                    const coord = coordAdjustment().adjustCentreForScreenSpace([1879921.6885150375, 5830466.109067537], window['map'], 9);

                    appScope.$apply(() => {
                        appScope.$broadcast(GeoAppEvents.queryPoint, coord);
                        waitFor('.inset-pane-xs point-report-list')
                            .then((list) => {
                                list.scrollIntoView();
                                workAroundMoveNext('i')
                            });
                    });
                },
                onPrevious: () => {
                    driver.preventMove();
                    waitFor('button.fab-menu-button.material-floating-button.active-mode')
                        .then(btn => btn.click())
                        .then(() => waitFor('.fab-menu-button.material-floating-button:not(.active-mode)'))
                        .then(btn => btn.click())
                        .then(() => workAroundMoveNext('g'))
                        .catch(timeoutHandler(driver));
                }
            },*/
            {
                _id: 'i',
                element: '.inset-pane-xs #PaneFeatures',
                popover: {
                    ...SMapTourSteps.soilSummaryPt3(false),
                    position: isPortrait() ? "top-right" : 'left-center'
                },
                onNext: () => {
                    driver.preventMove();
                    driver.preventMove();

                    waitFor('.pane-container:not(.pane-collapse-xs) .inset-pane-xs [data-action=showSMUFactsheet]')
                        .then(btn => {
                            btn.scrollIntoView();
                            btn.click();
                            workAroundMoveNext('i2');
                        })
                },
                onPrevious: () => {
                    driver.preventMove();
                    appScope.$apply(() => {
                        appScope.$broadcast(FeaturesEvents.hideReport);
                        appScope.$broadcast(GeoAppEvents.removeUnsavedPins);
                        togglePane(appScope, Panes.Ids.FEATURES, false);
                        waitFor('.pane-container.pane-collapse-xs')
                            /*.then(() => {
                                const btn = <HTMLElement> document.querySelector('.features-menu.fab-menu button.fab-menu-button');
                                btn.click();
                                return waitFor('[data-feature-action=pointQueryMobile]')
                            })
                            .then(() => {
                                (<HTMLElement> document.querySelector('[data-feature-action=pointQueryMobile]'))
                                    .click();
                            })*/
                            .then(() => workAroundMoveNext('f0'))
                            .catch(timeoutHandler(driver));
                    });
                }
            },
            {
                _id: 'i2',
                element: '#report-container > .fullscreen-report',
                popover: {
                    ...SMapTourSteps.smuReport(true),
                    position: 'mid-center'
                },
                onNext: () => {
                    driver.preventMove();

                    waitFor('.fullscreen-report .report-toolbar .close-button')
                        .then(btn => {
                            btn.click();
                            appScope.$broadcast(FeaturesEvents.hideReport);
                            appScope.$broadcast(GeoAppEvents.removeUnsavedPins);
                            togglePane(appScope, Panes.Ids.FEATURES, false);
                            return waitFor('body:not(.report-active)')
                        })
                        .then(() => waitFor('.pane-container.pane-collapse-xs'))
                        /*.then(() => {
                            return waitFor('.features-menu.fab-menu button[data-action=toggleFeaturesMenu]')
                        })
                        .then(btn => btn.click())*/
                        .then(() => workAroundMoveNext('f'));
                },
                onPrevious: () => {
                    driver.preventMove();
                    waitFor('.fullscreen-report .report-toolbar .close-button')
                        .then(btn => {
                            btn.click();
                            return waitFor('body:not(.report-active)');
                        })
                        .then(() => workAroundMoveNext('i'));
                }
            },
            {
                _id: 'f',
                element: '.features-menu.fab-menu',
                popover: {
                    ...SMapTourSteps.reportsButtonMobile,
                    position: 'top-right'
                },
                onNext: () => {
                    driver.preventMove();

                    waitFor('.features-menu.fab-menu button.fab-menu-button')
                        .then(btn => btn.click())
                        .then(() => waitFor('.features-menu.fab-menu .fab-menu-list'))
                        .then(() => workAroundMoveNext('f2'))
                        .catch(timeoutHandler(driver));
                },
                onPrevious: () => {
                    /*driver.preventMove();
                    togglePane(appScope, Panes.Ids.LAYERS, true)
                        .catch(() => {})
                        .then(() => waitFor(".inset-pane-xs #PaneLayers .pane-content")
                        .then(() => workAroundMoveNext('i2'))
                        .catch(timeoutHandler(driver)));*/

                    driver.preventMove();

                    const coord = coordAdjustment().adjustCentreForScreenSpace([1879921.6885150375, 5830466.109067537], window['map'], 9);

                    appScope.$apply(() => {
                        appScope.$broadcast(GeoAppEvents.queryPoint, coord);

                        waitFor('.inset-pane-xs #PaneFeatures')
                            .then(() => waitFor('.inset-pane-xs point-report-list'))
                            .then((list) => list.scrollIntoView())
                            .then(() => {
                                return waitFor('.pane-container:not(.pane-collapse-xs) .inset-pane-xs [data-action=showSMUFactsheet]')
                            })
                            .then(btn => {
                                btn.scrollIntoView();
                                btn.click();
                            })
                            .then(() => workAroundMoveNext('i2'))
                            .catch(timeoutHandler(driver));
                    });
                }
            },
            {
                _id: 'f2',
                element: 'ul.fab-menu-list',
                stageBackground: '#fff',
                popover: {
                    ...SMapTourSteps.areaReportMobile,
                    position: 'mid-center'
                },
                onNext: () => simpleNext('k'),
                onPrevious: () => {
                    driver.preventMove();

                    waitFor('.fab-menu-button.material-floating-button.active-mode')
                        .then(btn => btn.click())
                        .then(() => waitFor('.features-menu.fab-menu button.fab-menu-button:not(.active-mode)'))
                        .then(() => workAroundMoveNext('f'))
                        .catch(timeoutHandler(driver));
                }
            },
/*            {
                _id: 'j',
                element: '.features-menu.fab-menu .fab-menu-list',
                stageBackground: '#fff',
                popover: {
                    ...SMapTourSteps.areaReport,
                    position: 'mid-center' // compromise needed for the popup to be visible on small screens
                },
                onNext: () => simpleNext('k'),
                onPrevious: () => {
                    driver.preventMove();

                    const coord = coordAdjustment().adjustCentreForScreenSpace([1879921.6885150375, 5830466.109067537], window['map'], 9);

                    appScope.$apply(() => {
                        appScope.$broadcast(GeoAppEvents.queryPoint, coord);

                        waitFor('.inset-pane-xs #PaneFeatures')
                            .then(() => waitFor('.inset-pane-xs point-report-list'))
                            .then((list) => list.scrollIntoView())
                            .then(() => {
                                return waitFor('.pane-container:not(.pane-collapse-xs) .inset-pane-xs [data-action=showSMUFactsheet]')
                            })
                            .then(btn => {
                                btn.scrollIntoView();
                                btn.click();
                            })
                            .then(() => workAroundMoveNext('i2'))
                            .catch(timeoutHandler(driver));
                    });
                }
            },*/
            {
                _id: 'k',
                stageBackground: "#fff",
                element: '[data-feature-action="predefinedAreaMobile"][data-layer="LINZ Parcels"]',
                popover: {
                    ...SMapTourSteps.predefinedFeatures,
                    position: isPortrait() ? 'top-right' : 'left-center',
                },
                onNext: () => {
                    driver.preventMove();
                    doLinzQuery('l');
                },
                onPrevious: () => simpleNext('f2')
            },
            {
                _id: 'l',
                element: 'main',
                popover: {
                    ...SMapTourSteps.linzParcel,
                    position: 'mid-center'
                },
                onNext: () => {
                    driver.preventMove();

                    appScope.$apply(() => {
                        togglePane(appScope, Panes.Ids.FEATURES, false);
                        appScope.$emit(FeaturesEvents.hideReport);
                        resetMap(appScope, coordAdjustment());
                    });

                    setTimeout(() => workAroundMoveNext('o'), 16);
                },
                onPrevious: () => {
                    driver.preventMove();
                    appScope.$apply(() => {
                        featureState().hideReport();
                        // appScope.$broadcast(FeaturesEvents.hideReport);
                        appScope.$broadcast(GeoAppEvents.removeUnsavedPins);
                        togglePane(appScope, Panes.Ids.FEATURES, false);
                    });

                    waitFor('.pane-container.pane-collapse-xs')
                        .then(() => waitFor('.features-menu.fab-menu button.fab-menu-button'))
                        .then((btn: HTMLElement) => {
                            if (!btn.classList.contains('active-mode')) {
                                btn.click();
                            }
                            return delay(16);
                        })
                        .then(() => workAroundMoveNext('k'))
                        .catch(timeoutHandler(driver))
                }
            },
            {
                _id: 'o',
                element: '#ng-body',
                popover: {
                    ...SMapTourSteps.conclusion,
                    position: 'mid-center'
                },
                onPrevious: () => {
                    moveMap(mapService().map, coordAdjustment(), [1879921.6885150375, 5830466.109067537], 9);
                    driver.preventMove();
                    waitFor('.features-menu.fab-menu button.fab-menu-button')
                        .then(btn => {
                            btn.click();
                            return doLinzQuery('l');
                        })
                        .catch(timeoutHandler(driver));
                }
            }
        ];

        if (restartTour) {
            theSteps.unshift({
                _id: 'restarted',
                element: 'main > div',
                popover: {
                    ...SMapTourSteps.tourRestarted,
                    position: 'mid-center'
                },
                onNext: () => {
                    driver.preventMove();
                    theSteps.shift();
                    workAroundMoveNext('a');
                }
            })
        }

        return theSteps;
    };

    driver.defineSteps(steps(restarted));

    const ready = startWhenReady(driver, appScope, appElement, mapService());

    return <TourStatus> () => {
        return {
            driver,
            steps: steps(),
            ready,
            onOrientationChange: () => setTimeout(() => {
                console.log('redefining steps');

                const newSteps = steps(true);
                setTimeout(() => {
                    driver.defineSteps(newSteps);
                    startWhenReady(driver, appScope, appElement, mapService());
                });
            }, 100)
        }
    }
}
